import React from "react";
import { Card, CardContent } from "@/components/ui/card";

export const KpiCard = ({ icon: Icon, label, value, sub, testId }) => (
  <Card
    data-testid={testId}
    className="transition-shadow hover:shadow-md hover:-translate-y-[2px] transition-transform duration-200"
  >
    <CardContent className="p-4 sm:p-5">
      <div className="flex items-center gap-2 text-muted-foreground">
        {Icon && <Icon className="h-4 w-4" />}
        <span className="text-xs font-medium uppercase tracking-wide">{label}</span>
      </div>
      <div className="mt-2 text-2xl sm:text-3xl font-semibold font-num">{value}</div>
      {sub && <div className="mt-1 text-xs text-muted-foreground">{sub}</div>}
    </CardContent>
  </Card>
);
